<template>
  <div class="open-invoice-order my-invoice">
    <van-list v-model="loading"
              :finished="finished"
              finished-text="您没有更多记录了哦"
              @load="onLoad"
              :immediate-check="false"
              class="list-container"
              ref="vanList">
      <div class="list-item"
          v-for="(item,index) in list"
          :key="index"
          :title="item"
          @click="gotoOrderDetail(item)">
          <div class="item-header">
            <!-- <div class="radio">
              <img src="../../assets/img/radio.png" v-if="!item.select" alt="">
              <img src="../../assets/img/radio-yes.png" v-else alt="">
            </div> -->
            <div class="item-header-flex">{{item.staName | formatNullValue}} </div>
            <div class="order-status">已支付</div>
          </div>
          <div class="item-info">
            <div class="item-info-box">
              <div class="info-name">订单号</div>
              <div class="info-value">{{item.orderNo | formatNullValue}}</div>
            </div>
            <div class="item-info-box">
              <div class="info-name">开始时间</div>
              <div class="info-value">{{item.chargeBeginTime | formatNullValue}}</div>
            </div>
            <div class="item-info-box">
              <div class="info-name">时长</div>
              <div class="info-value">{{item.chargeMinutes | formatNullValue}}</div>
            </div>
            <!-- <div class="item-info-box">
              <div class="info-name">延时金额</div>
              <div class="info-value">{{item.delayAmount | formatNullValue}}</div>
            </div> -->
            <div class="item-info-box">
              <div class="info-name">电量(度)</div>
              <div class="info-value">{{item.chargeElect | formatNullValue}}</div>
            </div>
          </div>
          <div class="order-money">
            金额(元)<span class="money">{{item.transactionAmount}}</span>
          </div>
      </div>
    </van-list>
  </div>
</template>
<script>

import {chargeRecodeByInvoice} from '../../common/api/index'
import { List } from "vant";
export default {
  name: 'pi-open-invoice-order',
  data(){
    return{
      loading:false,
      finished:false,
      list: [],
      from:{
        globalPageIndex: 1,
        globalPageSize: 10,
        invoicePkIds: ''
      },
    }
  },
  components: {
    [List.name]: List,
  },
  methods: {
    gotoOrderDetail(item){
       this.$router.push({
          name: "my/order/details",
          query: { orderNo: item.orderNo }
        });
    },
    onLoad() {
      if (
        !this.finished 
      ) {
        this.form.globalPageIndex++;
        this.getInvoiceList();
      }
    },
    getInvoiceList(){
      chargeRecodeByInvoice(this.from).then(ret=>{
        this.list = this.list.concat(ret.data);
        this.loading = false;
        if(this.list.length >= ret.total){
          this.finished = true;
        }
      })
    },
  },
  mounted() {
    this.from.invoicePkIds = this.$route.query.invoicePkId;
    this.getInvoiceList();
     this.$common.bodyAddBg();
  },
  destroyed () {
    this.$common.removeBodyBg();
  },
}
</script>
<style lang="less">
@import url('../my-invoice/css/my-invoice.less');

</style>